import {
  // deletee,
  get,
  post,
  put,
} from "./index";

export const getAppointmentsList = (params) => {
  const request = {
    subUrl: `/general_consultations/list_invitations.json`,
    params,
  };
  return get(request);
};

export const bookAppointment = (data) => {
  const request = {
    subUrl: `/general_consultations/send_consultation_message.json`,
    data,
  };
  return post(request);
};

export const resendAppointmentInviteApi = (params) => {
  let { id } = params;
  const request = {
    subUrl: `/general_consultations/resend_appointment_invitation?id=${id}`,
    // params,
  };
  return get(request);
};

export const searchClinicianApi = (params) => {
  const request = {
    subUrl: `/address_books.json`,
    params,
  };
  return get(request);
};

export const getVideoCallTokens = (data) => {
  const request = {
    subUrl: `/general_consultations/get_tokens`,
    data,
  };
  return post(request);
};

export const addClinicianToAppointment = (data) => {
  const request = {
    subUrl: `/general_consultations/add_clinicians/${data.id}`,
    data,
  };
  delete data["id"];
  return put(request);
};

// https://localhost:3000/api/general_consultations/add_clinicians?appointment_id=362
